import React, { FC } from 'react';
import './Icon.scss';

export const RegularIcon: FC<{ src: string; alt?: string }> = ({ src, alt }) => (
    <img alt={alt ?? 'Menu Icon'} src={src} />
);
